/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'fabric.elements.mentions.team.member.50plus': 'Zespół z ponad 50 członkami',
  'fabric.elements.mentions.team.member.50plus.including.you': 'Zespół z ponad 50 członkami, łącznie z Tobą',
  'fabric.elements.mentions.team.member.count': '{0, plural, one {Zespół z 1 członkiem} few {Zespół z {0} członkami} many {Zespół z {0} członkami} other {Zespół z {0} członka}}',
  'fabric.elements.mentions.team.member.count.including.you': '{0, plural, one {Zespół z 1 członkiem, łącznie z Tobą} few {Zespół z {0} członkami, łącznie z Tobą} many {Zespół z {0} członkami, łącznie z Tobą} other {Zespół z {0} członka, łącznie z Tobą}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Potrzebuje dostępu do Confluence',
  'fabric.mention.error.defaultAction': 'Spróbuj ponownie za chwilę',
  'fabric.mention.error.defaultHeadline': 'Coś poszło nie tak',
  'fabric.mention.error.differentText': 'Spróbuj wpisać inny tekst',
  'fabric.mention.error.loginAgain': 'Spróbuj się wylogować i zalogować ponownie',
  'fabric.mention.noAccess.label': 'Brak dostępu',
  'fabric.mention.noAccess.warning': 'Użytkownik {name} nie zostanie powiadomiony, ponieważ nie ma dostępu',
  'fabric.mention.unknow.user.error': 'Nieznany użytkownik {userId}'
};